var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top w-100 px-0 background-white",
          staticStyle: { "z-index": "10" },
          attrs: { id: "nav-info", role: "navigation" }
        },
        [_c("interview-navi", { attrs: { navData: _vm.pageData } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container page-wrap",
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus
          }
        },
        [
          _vm.getHomeCarrier && _vm.isBothNonEndToEnd
            ? _c(
                "div",
                {
                  staticClass:
                    "row no-gutters mx-0 my-3 justify-content-center",
                  attrs: { id: "nonendtoend" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-10 non-end-to-end-col py-4 px-5" },
                    [
                      _c("div", { staticClass: "row mb-4" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 msg-col text-center" },
                          [
                            _c("img", {
                              staticClass: "mb-3 carrier-logo",
                              attrs: { src: _vm.getHomeCarrier.logoPathSvg }
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("Please continue to the "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.getHomeCarrier.carrier_name) + "'s"
                                )
                              ]),
                              _vm._v(
                                " agent platform in a new browser tab to complete the purchase of this " +
                                  _vm._s(_vm.flow) +
                                  " policy."
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 btn-col text-center" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary select-carrier-btn mb-2",
                                attrs: {
                                  disabled: _vm.isButtonDisable("home"),
                                  type: "button",
                                  tabindex: "0",
                                  role: "button"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.continueToHomeCarrier()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              CONTINUE TO " +
                                    _vm._s(_vm.getHomeCarrier.carrier_name) +
                                    "\n              "
                                ),
                                _c(
                                  "i",
                                  { staticClass: "fa fa-open-in-new ml-1" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 16 16",
                                          fill: "currentColor"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z",
                                            fill: "currentColor"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row no-gutters mx-0 my-3 justify-content-center",
              attrs: { id: "nonendtoend" }
            },
            [
              _c(
                "div",
                { staticClass: "col-10 non-end-to-end-col py-4 px-5" },
                [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col-12 msg-col text-center" }, [
                      _c("img", {
                        staticClass: "mb-3 carrier-logo",
                        attrs: { src: _vm.getSrc }
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm.checkBundleCarriers
                          ? _c("span", [_vm._v("1. ")])
                          : _vm._e(),
                        _vm._v("Please continue to the "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.getCarrierName) + "'s")
                        ]),
                        _vm._v(
                          " agent platform in a new browser tab to complete the purchase of this " +
                            _vm._s(_vm.carrierType) +
                            " policy."
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 btn-col text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary select-carrier-btn mb-2",
                          attrs: {
                            disabled: _vm.isButtonDisable("other"),
                            type: "button",
                            tabindex: "0",
                            role: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.continueToSelectedCarrier()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              CONTINUE TO " +
                              _vm._s(_vm.getCarrierName) +
                              "\n              "
                          ),
                          _c("i", { staticClass: "fa fa-open-in-new ml-1" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 16 16",
                                  fill: "currentColor"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z",
                                    fill: "currentColor"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.checkBundleCarriers
                    ? _c("div", { staticClass: "row mt-4" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 msg-col text-center" },
                          [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.second_msg_line)
                              }
                            })
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-2" }, [
            _c("div", { staticClass: "col-12 text-center bottom-msg-line" }, [
              _c("p", [
                _vm._v(
                  "All of your quote information has been saved in QRP Agent Portal."
                )
              ]),
              _vm._v(" "),
              !_vm.checkBundleCarriers
                ? _c("p", { staticClass: "mt-4" }, [
                    _vm._v(
                      "Go to the Search Results page to begin a new quote."
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.checkBundleCarriers
            ? _c(
                "div",
                { staticClass: "form-row justify-content-center mx-0" },
                [
                  _c("div", { staticClass: "col-10 text-center py-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn",
                        attrs: { type: "submit" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.endToEndSubmitted($event)
                          }
                        }
                      },
                      [
                        _vm._v(_vm._s(_vm.submitButtonLabel) + "\n          "),
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "25",
                              height: "24",
                              viewBox: "0 0 25 24",
                              fill: "currentColor",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id:
                                    "&#240;&#159;&#166;&#134; icon &#34;arrow-right-thick&#34;"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    id: "Vector",
                                    d:
                                      "M4.5 10.0001V14.0001H13.5L10 17.5001L12.42 19.9201L20.34 12.0001L12.42 4.08008L10 6.50008L13.5 10.0001H4.5Z",
                                    fill: "currentColor"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.isBothFlowBound
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBindError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40d8b614", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d8b614","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/NonEndToEnd.vue
// module id = null
// module chunks = 